<!-- 和键盘快捷键【 ↑ ↓ ← → enter 】绑定的列表组件 -->
<template>
    <ul v-show="listVisible">
        <li :title="valueKey ? (item[valueKey] || '') : item" :class="activeIndex === index ? 'active' : ''" @click="clickItem(item, index)" v-if="index < maxNum" v-for="(item, index) in listData">{{ valueKey ? (item[valueKey] || '') : item }}</li>
    </ul>
</template>

<script>
    export default {
        props: {
            valueKey: {
                type: String
            },
            maxNum: {
                type: Number,
                default: 10
            },
            listData: {
                type: Array,
                required: true
            },
            listVisible: {
                type: Boolean,
                required: true
            }
        },
        data () {
            return {
                activeIndex: null
            }
        },
        computed: {
            masKey () {
                let dataLen = this.listData.length
                return this.maxNum > dataLen ? dataLen - 1 : this.maxNum - 1
            }
        },
        methods: {
            clickItem (value, index) {
                this.$emit('update:listVisible', false)
                this.$emit('click-item', value)
            },
            selectItem (value, index) {
                this.$emit('select-item', value)
            },
            downItem () {
                if (this.activeIndex === this.masKey) {
                    this.activeIndex = null
                    this.$emit('no-checked')
                } else {
                    if (this.activeIndex !== null) {
                        this.activeIndex++
                    } else {
                        this.activeIndex = 0
                    }
                    this.selectItem(this.listData[this.activeIndex], this.activeIndex)
                }
            },
            upItem () {
                if (this.activeIndex === 0) {
                    this.activeIndex = null
                    this.$emit('no-checked')
                } else {
                    if (this.activeIndex !== null) {
                        this.activeIndex--
                    } else {
                        this.activeIndex = this.masKey
                    }
                    this.selectItem(this.listData[this.activeIndex], this.activeIndex)
                }
            }
        },
        mounted () {
            let self = this

            document.onkeydown = event => {
                let key = event.keyCode
                if (self.listVisible) {
                    if (key === 38) { // up
                        self.upItem()
                    } else if (key === 40) { // down
                        self.downItem()
                    } else {}
                }
            }
        },
        watch: {
            listVisible (newVal) {
                if (!newVal) {
                    this.activeIndex = null
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/backtest/main.scss';
    li {
        height: 36px;
        width: 100%;
        font-size: 12px;
        line-height: 36px;
        padding-left: 5px;
        padding-right: 5px;
        overflow: hidden;
        cursor: pointer;
        &:hover {
            background: #eaf4ff;
        }
        &.active {
            background: #eaf4ff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/lib/key-list.vue